import styled from 'styled-components';
import { Box } from '../Box';
export var ModalBody = styled(Box).attrs({
  'data-test': 'modal-body'
}).withConfig({
  displayName: "ModalBody",
  componentId: "sc-b99thl-0"
})(["min-height:100px;overflow-y:auto;"]);